import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const Projects = lazy(() => import('./Projects'));

export const projectRoutes: RouteObject[] = [
  { path: 'projects', element: <Projects /> },
];
